/*!
   angular-form-gen-ws v0.2.5
   (c) 2017 (null) McNull https://github.com/McNull/angular-form-gen
   License: MIT
*/
(function(angular) {
